import React, { useState } from 'react';
import { FaTimes, FaLock, FaCheckCircle, FaSpinner } from 'react-icons/fa';

const OtpModal = ({ email, onClose }) => {
  const [otp, setOtp] = useState('');
  const [status, setStatus] = useState('pending');
  const [message, setMessage] = useState('');

  const handleOtpChange = (e) => {
    setOtp(e.target.value.replace(/\s/g, ''));
  };

  const handleVerification = async (e) => {
    e.preventDefault();
    setMessage('');
    
    if (otp.length !== 6) {
      setMessage('OTP must be 6 digits.');
      setStatus('error');
      return;
    }
    
    setStatus('processing');
    
    try {
      const response = await fetch('http://localhost:4000/api/local/verify_otp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, otp }),
        credentials: 'include',
      });

      const data = await response.json();

      if (response.ok) {
        setStatus('success');
        setMessage(data.message);
        
        // On successful verification and auto-login, redirect to homepage
        setTimeout(() => {
          window.location.href = '/'; 
        }, 1500); 

      } else {
        setStatus('error');
        setMessage(data.message || "OTP verification failed. Please try again.");
      }
    } catch (error) {
      setStatus('error');
      setMessage("Network error. Could not verify OTP.");
    }
  };

  return (
    <div className="modal-overlay" onClick={status === 'success' ? null : onClose}>
      <div className="modal-content bg-slate-800" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="modal-close-button text-white">
          <FaTimes />
        </button>
        
        {status === 'success' ? (
          <div className="text-center p-8">
            <FaCheckCircle className="text-green-500 text-6xl mx-auto mb-4" />
            <h2 className="text-3xl font-bold text-white">Verification Complete!</h2>
            <p className="text-slate-400 mt-2">{message}</p>
          </div>
        ) : (
          <div className="p-4">
            <h2 className="text-2xl font-bold text-amber-400 mb-2">Verify Your Email</h2>
            <p className="text-slate-400 mb-6">A 6-digit code has been sent to **{email}**.</p>
            
            {message && (
                <div className={`p-3 rounded-lg mb-4 font-semibold ${status === 'error' ? 'bg-red-600' : 'bg-slate-700'} text-white text-sm`}>
                  {message}
                </div>
            )}
            
            <form onSubmit={handleVerification} className="space-y-6">
              <div className="relative">
                <FaLock className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400" />
                <input
                  type="text"
                  placeholder="Enter 6-Digit OTP"
                  value={otp}
                  onChange={handleOtpChange}
                  maxLength="6"
                  required
                  className="w-full py-3 pl-12 pr-4 bg-slate-900 text-white rounded-lg border border-slate-700 focus:ring-amber-400 focus:border-amber-400 text-center text-xl tracking-widest"
                />
              </div>
              
              <button
                type="submit"
                disabled={status === 'processing'}
                className="w-full py-3 bg-amber-400 text-slate-950 font-bold rounded-lg hover:bg-amber-500 transition duration-300 shadow-md flex items-center justify-center space-x-2"
              >
                {status === 'processing' ? (
                  <>
                    <FaSpinner className="animate-spin" /> <span>Verifying...</span>
                  </>
                ) : (
                  <span>Verify and Log In</span>
                )}
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default OtpModal;